import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

const privacyText = `
Privacy Updates
Note: due to recent privacy updates from Facebook, we are only able to return the approximate range of the shares, plus or minus a few percent.

As an example: if the share count is < 50, it may return a range from 0-50. If the share count is 112, it may return a range of 90-120.

As the share count gets higher, the range gets tighter as a function of %. Let's say the share count is 583, it may return a range of 550-600.
`;
const tooltipStyle = {
    backgroundColor: 'lightblue',
    color: 'black',
    border: '1px solid #333',
    borderRadius: '4px',
    padding: '8px',
};

function PrivacyUpdates() {
    return (
        <div>
            <p>
                Privacy Updates
            </p>
            <p>
                Note: due to recent privacy updates from Facebook, we are only able to return the approximate range of the shares, plus or minus a few percent.
            </p>

            <p>
                As an example:
            </p>
            <ul>
                <li>If the share count is less than 50, it may return a range from 0-50.</li>
                <li>If the share count is 112, it may return a range of 90-120.</li>
            </ul>
            <p>
                As the share count gets higher, the range gets tighter as a function of %. Let's say the share count is 583, it may return a range of 550-600.
            </p>
        </div>
    );
}

class PrivacyUpdateTooltip extends Component {
    render() {
        return (
            <div id="privacy_update" data-tip="This is a tooltip" data-for="privacy-update-tooltip">
                <svg viewBox="0 0 416.979 416.979" xmlns="http://www.w3.org/2000/svg">
                    <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85
                                        c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786
                                        c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576
                                        c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765
                                        c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"/>
                </svg>

                <ReactTooltip
                    id="privacy-update-tooltip"
                    className="tooltip-privacy-update"
                    place="top"
                    effect="solid">
                    <PrivacyUpdates />
                </ReactTooltip>
            </div>
        );
    }
}
export default PrivacyUpdateTooltip;